var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { initialSportsDataFeed } from "./SportDataGateWayRetriever";
import { observe, observable, action } from "mobx";
import { Time } from "sb-resp-utils";
import { EventsManager } from "sb-js-extends";
import { OddStyles } from "sb-legacy-integration";
import { DeviceDetectHelper } from "../../parser";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { OddStyles as OddStyleMap } from "../../data/models/Selection";
import { BetslipUtilChannels, BsUtilReceivers } from "sb-betslip-utils-contracts";
/*
    The class has 'istanbul ignore' flag , because of testing typescript interface with Jest.
    It`s known issue : (https://github.com/kulshekhar/ts-jest/issues/378)
    The class is fully tested, but property "sportsDataChangeFeed" implement interface "ChangeFeedUpdate" which is not
    testable with Jest - there is no types like in typescript
 */
/* istanbul ignore next */
export class DataFacade {
    constructor(options) {
        this.dataCollection = initialSportsDataFeed;
        this.eventsIds = options.eventsIds;
        this.cms = options.cms;
        this.sportDataGateway = options.sportDataGatewayRetriever;
        this.navHandler = options.utils.navHandler;
        this.deviceDetectHelper = options.utils.deviceDetect;
        this.isUserLoggedIn = false;
        this.shouldRemoveEvents = false;
        this.blockUniqueId = options.blockUniqueId;
        this.eventsManager = new EventsManager();
        this.timeControl = options.utils.timeControl;
        this.currentTimeZone = this.timeControl.getCurrentTimeZone();
        this.dateFormat = options.dateFormat;
        this.timeFormat = options.timeFormat;
        this.currentOddStyle = OddStyles[options.currentOddStyleIndex];
        this.timeInstance = Time.getInstance;
        this.userInfo = options.userInfo;
        this.messageBus = options.messageBus;
        this.betslipItems = observable([]);
        this.betslipReceiverIds = [BsUtilReceivers.FullBetSlip];
        let timeProvider = {
            getServerDate: this.timeControl.getServerTime,
            currentTimeZone: this.timeControl.getCurrentTimeZone().toString()
        };
        this.timeInstance.init(timeProvider);
        this.setIsUserLoggedIn(!!this.userInfo.current);
        this.userInfo.onLogin[options.blockUniqueId] = this.setIsUserLoggedIn.bind(this, true);
        this.userInfo.onLogout[options.blockUniqueId] = this.setIsUserLoggedIn.bind(this, false);
        this.updateCollection = this.updateCollection.bind(this);
        this.cms.DisplayMobileMode = this.deviceDetectHelper.deviceDetect.isMobile &&
            this.cms.DisplayMobileMode;
        this.cms.DisplayMultipleItems = (this.deviceDetectHelper.deviceDetect.isDesktop &&
            this.cms.DisplayMultipleItems) ||
            this.deviceDetectHelper.deviceDetect.isTablet ||
            this.deviceDetectHelper.deviceDetect.isMobile;
        this.currentSelectedSportId = options.currentSelectedSportId;
        this.updateOddStyleOfEventsFromMessage = this.updateOddStyleOfEventsFromMessage.bind(this);
        this.updateOddStyleOfEventsOnRequest = this.updateOddStyleOfEventsOnRequest.bind(this);
        this.isMBNEnabled = options.isMBNEnabled;
        // observe this.sportDataGateway["sportsDataChangeFeed"]
        // for changes and call "updateCollection" with changeFeed from Sports Data API
    }
    // should activate main flow of the Facade, activate from outside
    activate() {
        this.disposeSportsDataFeed = observe(this.sportDataGateway, "sportsDataChangeFeed", (change) => {
            this.updateCollection(change.newValue);
        });
        this.disposeRemoveOfEvents = observe(this.sportDataGateway, "shouldRemoveEvents", (change) => {
            this.shouldRemoveEvents = change.newValue;
        });
        this.disposeTimeZone = observe(this.timeInstance, (change) => {
            let changedObject = change.object;
            change.name === "currentTimeZone" && this.updateTimeZone(changedObject.currentTimeZone);
        });
        this.messageBus.on(InternalMessageBusChannels.legacy.oddStyle.update, this.updateOddStyleOfEventsFromMessage);
        this.subscribeForHighlightEvents();
        this.eventsManager.addEventListener("oddStyleChanged", this, this.updateOddStyleOfEvents, true);
        this.eventsManager.addEventListener("onBranchRemoved", this, this.resetCurrentSelectedSportId, true);
        this.requestOddStyle();
        this.updateTimeZone(this.timeControl.getCurrentTimeZone());
        this.addBetslipListeners();
    }
    deactivate() {
        this.disposeSportsDataFeed();
        this.sportDataGateway.deactivate();
        this.eventsManager.removeEventListener("oddStyleChanged", this, true);
        this.eventsManager.removeEventListener("onBranchRemoved", this, true);
        this.messageBus.off(InternalMessageBusChannels.legacy.oddStyle.update, this.updateOddStyleOfEventsFromMessage);
        this.removeBetslipListeners();
    }
    subscribeForHighlightEvents() {
        this.sportDataGateway.activate(this.eventsIds);
    }
    updateCollection(dataFeed) {
        this.dataCollection = dataFeed;
    }
    updateTimeZone(newTime) {
        if (!isNaN(newTime)) {
            this.currentTimeZone = newTime;
        }
    }
    updateOddStyleOfEvents(oddStyle) {
        if (!isNaN(oddStyle)) {
            this.currentOddStyle = OddStyleMap[OddStyles[oddStyle]];
        }
    }
    setIsUserLoggedIn(isUserLoggedIn) {
        this.isUserLoggedIn = isUserLoggedIn;
    }
    resetCurrentSelectedSportId() {
        this.setCurrentSelectedSportId(0);
    }
    setCurrentSelectedSportId(sportId) {
        if (sportId >= 0) {
            this.currentSelectedSportId = sportId;
        }
    }
    requestOddStyle() {
        this.messageBus.emit(InternalMessageBusChannels.legacy.oddStyle.request, { callback: this.updateOddStyleOfEventsOnRequest });
    }
    updateOddStyleOfEventsFromMessage(message) {
        if (message && message.data && message.data[0] && typeof (message.data[0].currentSelectedOddStyle) !== "undefined") {
            this.updateOddStyleOfEvents(message.data[0].currentSelectedOddStyle);
        }
    }
    updateOddStyleOfEventsOnRequest(message) {
        if (message) {
            this.updateOddStyleOfEvents(message.currentSelectedOddStyle);
        }
    }
    addBetslipStatusListener() {
        this.messageBus.on(BetslipUtilChannels.Broadcast.Status, this.onBetslipStatus);
    }
    removeBetslipStatusListener() {
        this.messageBus.off(BetslipUtilChannels.Broadcast.Status, this.onBetslipStatus);
    }
    addBetslipListeners() {
        this.messageBus.on(BetslipUtilChannels.Broadcast.Items.added, this.onSelectionAddedToBetslip);
        this.messageBus.on(BetslipUtilChannels.Broadcast.Items.removed, this.onSelectionRemovedFromBetslip);
        this.messageBus.on(BetslipUtilChannels.Broadcast.Items.cleared, this.onBetslipCleared);
        this.addBetslipStatusListener();
    }
    removeBetslipListeners() {
        this.messageBus.off(BetslipUtilChannels.Broadcast.Items.added, this.onSelectionAddedToBetslip);
        this.messageBus.off(BetslipUtilChannels.Broadcast.Items.removed, this.onSelectionRemovedFromBetslip);
        this.messageBus.off(BetslipUtilChannels.Broadcast.Items.cleared, this.onBetslipCleared);
        this.removeBetslipStatusListener();
    }
    requestBetslipStatus() {
        this.messageBus.emit(BetslipUtilChannels.Listen.Commands.get_status);
    }
    /**
     * Betslip Util handlers/emitters
     */
    sendAddSelectionToBetslipMsg(items) {
        let message = {
            receiverIds: this.betslipReceiverIds,
            items
        };
        this.messageBus.emit(BetslipUtilChannels.Listen.Commands.add_items, message);
    }
    sendRemoveSelectionToBetslipMsg(items) {
        let message = {
            receiverIds: this.betslipReceiverIds,
            items
        };
        this.messageBus.emit(BetslipUtilChannels.Listen.Commands.remove_items, message);
    }
    onSelectionAddedToBetslip(msg) {
        if (msg.data.length) {
            const items = msg.data[0].items;
            this.betslipItems = [...this.betslipItems, ...items];
        }
    }
    onSelectionRemovedFromBetslip(msg) {
        if (msg.data.length) {
            const items = msg.data[0].items;
            const selectionIdsToRemove = items.map(item => item.selectionId);
            this.betslipItems = this.betslipItems.filter(i => selectionIdsToRemove.indexOf(i.selectionId) < 0);
        }
    }
    onBetslipCleared() {
        this.betslipItems = [];
    }
    onBetslipStatus(msg) {
        if (msg.data.length) {
            this.betslipItems = msg.data[0].items;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DataFacade.prototype, "dataCollection", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataFacade.prototype, "eventsIds", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DataFacade.prototype, "shouldRemoveEvents", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], DataFacade.prototype, "currentSelectedSportId", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], DataFacade.prototype, "currentTimeZone", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], DataFacade.prototype, "currentOddStyle", void 0);
__decorate([
    observable,
    __metadata("design:type", DeviceDetectHelper)
], DataFacade.prototype, "deviceDetectHelper", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DataFacade.prototype, "isUserLoggedIn", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DataFacade.prototype, "betslipItems", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "updateTimeZone", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "updateOddStyleOfEvents", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "setIsUserLoggedIn", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "resetCurrentSelectedSportId", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "setCurrentSelectedSportId", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "onSelectionAddedToBetslip", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "onSelectionRemovedFromBetslip", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "onBetslipCleared", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DataFacade.prototype, "onBetslipStatus", null);
//# sourceMappingURL=DataFacade.js.map